import { render, staticRenderFns } from "./HeaderAvatar.vue?vue&type=template&id=87935a56&scoped=true&"
import script from "./HeaderAvatar.vue?vue&type=script&lang=js&"
export * from "./HeaderAvatar.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAvatar.vue?vue&type=style&index=0&id=87935a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87935a56",
  null
  
)

export default component.exports